import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PAGE_FEATURE_KEY, PageState } from './data-access-page.reducer';
import { AnyPage, PageData } from './data-access-page.model';

export const selectPageState = createFeatureSelector<PageState>(PAGE_FEATURE_KEY);

export const selectCurrentPages = createSelector(selectPageState, (state) => state.currentPages);

export const hasFilledLeftPage = createSelector(
  selectCurrentPages,
  (pages: PageData[]) => !!pages?.find((page) => page.type === 'left' && !isEmptyPage(page))
);
export const hasFilledRightPage = createSelector(
  selectCurrentPages,
  (pages: PageData[]) => !!pages?.find((page) => page.type === 'right' && !isEmptyPage(page))
);
export const hasFilledCurrentPage = createSelector(
  selectCurrentPages,
  (pages: PageData[]) => !!pages?.find((page) => page.type === 'current' && !isEmptyPage(page))
);
export const isSinglePage = createSelector(
  selectCurrentPages,
  (pages: PageData[]) => !!pages?.find((page) => page.type === 'current')
);

export const selectIsDownloadingPages = createSelector(selectPageState, (state) => state.isDownloading);

const isEmptyPage = (page: AnyPage): boolean => page?.name === '.';
